/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component } from '@angular/core';
import { I18nService, PermissionService } from '@dm/core';
import { SmartGuiService } from 'app/common/services';

@Component({
    selector: 'app-smartgui-switch',
    templateUrl: './smartgui-switch.component.html',
    styleUrls: ['./smartgui-switch.component.scss'],
})
export class SmartguiSwitchComponent implements OnInit {
    switchEnableTip = this.i18nService.get('home.device_term_enableSmartRecommend_tip');
    switchUnableTip = this.i18nService.get('home.device_term_disenableSmartRecommend_tip');

    constructor(
        private i18nService: I18nService,
        public smartguiService: SmartGuiService,
        private permissionService: PermissionService,
    ) { }

    ngOnInit(): void {
        // 获取开关状态
        this.smartguiService.getSwitchState();
    }

    changeSwitchState(): void {
        // 有system_W权限才能修改开关状态，无权限弹窗提示
        this.permissionService.checkDepPermission(['system_W'])
            .subscribe(() => {
                this.smartguiService.toggleSwitch();
            });
    }
}
